import { useCallback } from "react";

import { useSidebar } from "@synthesis/shared-ui";

import { NOTIFICATIONS_SIDEBAR_OPTIONS } from "../notifications-panel.lib";
import { NotificationsPanel } from "../notifications-panel";

export const useNotificationsSidebar = () => {
  const sidebar = useSidebar();

  const open = useCallback(() => {
    sidebar.open({
      body: {
        content: <NotificationsPanel />,
      },
      options: NOTIFICATIONS_SIDEBAR_OPTIONS,
    });
  }, [sidebar]);

  const close = useCallback(() => {
    sidebar.close();
  }, [sidebar]);

  return { close, open };
};
